import "./Login.css";
import password_icon from "../../Assets/password.png";
import { useState } from "react";
import { ResponseMessage } from "../../models/ResponseMessage";
import { resetPasswordAsync } from "../../api/AccountApi";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getFieldValidationErrors } from "../../models/ValidationProblemDetails";
import { usePasswordValidation } from "../../hooks/usePasswordValidation";
import { PASSWORD_POLICY_ERROR_MESSAGE } from "../../utils/passwordPolicy";
import PasswordRequirements from "../../components/PasswordRequirements";

const Login: React.FC = () => {
  const [newPassword, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const {
    checks,
    checklistId,
    isValid,
    touched,
    showError,
    handleBlur,
    reset,
  } = usePasswordValidation(newPassword);

  const [searchParams] = useSearchParams();
  const refreshToken: string = searchParams.get("token") ?? "";
  const navigate = useNavigate();
  //const navigate = useNavigate();

  if (!refreshToken) {
    alert("Invalid Token");
    return;
  }

  const handleResetPassword = async () => {
    if (!confirmPassword || !newPassword) {
      alert("Please fill all the fields");
      return;
    }

    if (confirmPassword !== newPassword) {
      alert("Password donot match");
      return;
    }

    handleBlur();

    if (!isValid) {
      alert(PASSWORD_POLICY_ERROR_MESSAGE);
      return;
    }

    try {
      const response: ResponseMessage<boolean> = await resetPasswordAsync(
        refreshToken,
        newPassword
      );

      if (response.success) {
        alert("Password reset successful");
        navigate("/login");
      } else {
        alert("Password reset failed");
      }
    } catch (error) {
      const validationErrors = getFieldValidationErrors(error, {
        NewPassword: "newPassword",
      });
      if (Object.keys(validationErrors).length > 0) {
        setFieldErrors(validationErrors);
        alert(validationErrors.newPassword ?? PASSWORD_POLICY_ERROR_MESSAGE);
      } else {
        alert("Network error");
      }
    }
  };

  return (
    <div className="container">
      <div className="holder_login">
        <div className="inputs">
          <label className="name">Reset Your Password</label>
          <div className="input-wrapper">
            <img
              className="input-icon"
              src={password_icon}
              alt="password icon"
            />
            <input
              className="input"
              type="password"
              placeholder="Password"
              value={newPassword}
              maxLength={128}
              aria-invalid={showError || !!fieldErrors.newPassword}
              aria-describedby={checklistId}
              onChange={(e) => {
                setPassword(e.target.value);
                setFieldErrors((prev) => {
                  const next = { ...prev };
                  delete next.newPassword;
                  return next;
                });
              }}
            />
            {(showError || fieldErrors.newPassword) && (
              <p className="password-field-error" role="alert">
                {fieldErrors.newPassword ?? PASSWORD_POLICY_ERROR_MESSAGE}
              </p>
            )}
          </div>

          <div className="input-wrapper">
            <img
              className="input-icon"
              src={password_icon}
              alt="password icon"
            />
            <input
              className="input"
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <PasswordRequirements checks={checks} id={checklistId} />
          <div className="login-create-account">
            <button className="login-btn" onClick={handleResetPassword}>
              Reset Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
